export {
  conversationQueriesApi,
  useGetConversationsQuery,
  useGetInfiniteConversationsQuery,
  useGetConversationByIdQuery,
  useLazyGetConversationByIdQuery,
} from './endpoints/queries';
export type { ConversationsListResult } from './endpoints/queries';

export {
  conversationMutationsApi,
  recentlyMutatedConversationIds,
  useCreateConversationMutation,
  useUpdateConversationMutation,
  useDeleteConversationMutation,
  useToggleConversationStatusMutation,
  useToggleConversationMuteMutation,
  useGetOrCreateContactConversationWithMessageMutation,
  useGetOrCreatePhoneConversationWithMessageMutation,
  useGetOrCreateContactConversationMutation,
  useGetOrCreatePhoneConversationMutation,
  useMarkConversationAsReadMutation,
  useSendReviewRequestMutation,
} from './endpoints/mutations';

export {
  reviewRequestApi,
  useGetReviewRequestStatsQuery,
  useLazyGetReviewRequestContactStatusQuery,
} from './endpoints/review-request';

export {
  archivedConversationsApi,
  useGetArchivedConversationsQuery,
  useGetArchivedConversationDetailsQuery,
  useRestoreArchivedConversationMutation,
  useBulkRestoreArchivedConversationsMutation,
  usePermanentDeleteArchivedConversationMutation,
  useBulkDeleteArchivedConversationsMutation,
} from '../archive/endpoints/conversations';

export {
  conversationArchiveApi,
  useArchiveConversationMutation,
  useRestoreConversationMutation,
} from './endpoints/archive';

export type {
  ApiCreateConversationBody,
  ApiAddParticipantBody,
  ApiToggleConversationArchiveBody,
  ApiToggleMuteBody,
  ApiTogglePinBody,
  ApiToggleActiveBody,
  ApiPhoneConversationBody,
  ApiMarkReadBody,
  BackendConversation,
  Assignee,
  Tag,
  OtherContact,
  Participant,
  AssigneeType,
  ConversationViewType,
  GetConversationsParams,
  ConversationData,
  UiConversation,
} from './types';

export {
  transformConversation,
  transformConversations,
} from './transformers/conversation';
